import {activeTheme} from "@frontend/themes/activeTheme"

export type {WidgetChrome} from "@frontend/themes/types"

/**
 * Widget / chat chrome that sits outside the Panda token system (inline
 * styles / injected CSS). The actual per-brand values live in each theme's
 * `ThemeDefinition` under `themes/brands/`; this module only re-exports the
 * active brand's chrome so the many widget components that already import
 * `widgetChrome` don't need to change.
 */
export const widgetChrome = activeTheme.chrome
